import React, { useState, useEffect } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    MachineTranslationButton,
    raiseErrorToast,
    setTranslateOnLoad,
    getTranslateOnLoad,
} from '@fiverr-private/machine_translation';
import { translatePersonalizedContent } from '../../utils/personalizedContent';
import { buildSourceInfo } from '../../utils/machineTranslation/buildSourceInfo';
import { SUB_HEADER } from '../../utils/constants/recommendations';
import { useTranslationContext } from '../../context/TranslationContext';
import SafeComponent from '../SafeComponent';

const MachineTranslationButtonWrapper = () => {
    const { locale } = getContext();
    const { personalizedContentMap, showTranslatedContent, isInitialized, onTranslationToggle } =
        useTranslationContext();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isInitialized) {
            translateOnLoad();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInitialized]);
    const sourceInfo = buildSourceInfo({ componentName: SUB_HEADER });

    const onClick = async () => {
        setTranslateOnLoad(!showTranslatedContent);

        if (showTranslatedContent || !!personalizedContentMap?.translated) {
            onTranslationToggle();
        } else {
            await translateContent();
        }
    };

    const translateContent = async () => {
        try {
            setLoading(true);

            const translatedPersonalizedContent = await translatePersonalizedContent({
                personalizedContent: personalizedContentMap?.original,
                targetLocale: locale,
                sourceInfo,
            });

            onTranslationToggle(translatedPersonalizedContent);
            setLoading(false);
        } catch (_error) {
            setLoading(false);
            raiseErrorToast();
        }
    };

    const isTranslationOnLoadEnabled = () => getTranslateOnLoad();

    const translateOnLoad = async () => {
        if (isTranslationOnLoadEnabled()) {
            await translateContent();
        }
    };

    return (
        <section className="m-b-24">
            <MachineTranslationButton
                style={MachineTranslationButton.STYLES.LEAN_WITH_DISCLAIMER}
                loading={loading}
                toggled={showTranslatedContent}
                sourceInfo={sourceInfo}
                onClick={onClick}
            />
        </section>
    );
};

export { MachineTranslationButtonWrapper };
export default SafeComponent(MachineTranslationButtonWrapper);
